import axios from "axios";
import { apiEndPoints } from "./constants";
import { dateTime } from "./dateTime";

const API_URL = process.env.REACT_APP_API;
export const userDetails = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}${apiEndPoints.details}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${data?.code}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.status >= 500 || error.message === "Network Error") {
      throw new Error("Network Error");
    }
    throw new Error(error.response.data.message || "Verification Failed");
  }
};
export const verifyApi = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}${apiEndPoints.verify}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${data}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.status >= 500 || error.message === "Network Error") {
      throw new Error("Network Error");
    }
    throw new Error(error.response.data.message || "Verification Failed");
  }
};

export const getRoomsApi = async () => {
  try {
    const response = await axios.get(`${API_URL}${apiEndPoints.getRoom}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message);
  }
};

export const roomJoinApi = async (roomId) => {
  const currDateTime = dateTime();
  try {
    const response = await axios.post(
      `${API_URL}${apiEndPoints.roomJoin}/${roomId}`,
      {
        entryTimeAt: currDateTime,
      },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.response.data.message);
  }
};

export const roomLeaveApi = async (roomId) => {
  const currDateTime = dateTime();
  try {
    const response = await axios.post(
      `${API_URL}${apiEndPoints.roomLeave}/${roomId}`,
      {
        exitTimeAt: currDateTime,
      },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.response.data.message);
  }
};
